import React from 'react';
import PropTypes from 'prop-types';
import LOADER from '../../assets/animation/loader.gif';

const Loader = (props) => {
  const { style, ...rest } = props;
  return (
    <div style={style} {...rest}>
      <img src={LOADER} style={{ width: 50 }} alt="loader" />
    </div>
  );
};

Loader.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
};

Loader.defaultProps = {
  color: null,
  style: null,
};

export default Loader;
